const CHECKIN_I18N = {
  fr: {
    // Login
    login_title:      'Check-in Scanner',
    login_email:      'Email',
    login_password:   'Mot de passe',
    login_btn:        'Accéder au scanner',
    login_loading:    'Connexion…',
    login_error:      'Identifiants invalides ou accès refusé.',

    // Header
    header_checkin:   'Check-in',
    header_present:   'présents',

    // Tabs
    tab_scan:         'Scanner',
    tab_list:         'Participants',

    // Scanner
    scan_title:       'Scanner un badge',
    scan_subtitle:    'Appuyez sur le bouton ci-dessous pour ouvrir la caméra et scanner le QR code d\'un participant.',
    scan_btn:         'Scanner un badge',
    scan_aim:         'Pointez sur le QR code du badge',
    scan_flip:        'Retourner caméra',
    scan_stop:        'Arrêter',

    // Participant card
    card_current:     'Statut actuel',
    card_cancel:      'Annuler',
    card_confirm:     'Confirmer Check-in',
    card_already:     'Déjà enregistré',

    // Résultats
    result_success:   'Check-in confirmé !',
    result_already:   'Déjà enregistré',
    result_error:     'Erreur',
    result_invalid_qr: 'QR Code invalide',
    result_invalid_sub: 'Ce badge ne contient pas d\'identifiant.',
    result_bad_format: 'QR Code illisible',
    result_bad_sub:   'Format non reconnu.',
    result_network:   'Erreur réseau',
    result_network_sub: 'Vérifiez votre connexion.',

    // Statuts
    status_present:   'Présent',
    status_absent:    'Non arrivé',
    status_cancelled: 'Annulé',

    // Liste
    list_search:      'Rechercher un participant…',
    list_present:     'présents',
    list_empty:       'Aucun participant trouvé',
    list_checkin_btn: 'Check-in',
    list_undo_btn:    'Annuler',

    // Chargement
    loading:          'Chargement…',
  },

  de: {
    login_title:      'Check-in Scanner',
    login_email:      'E-Mail',
    login_password:   'Passwort',
    login_btn:        'Zum Scanner',
    login_loading:    'Verbinden…',
    login_error:      'Ungültige Anmeldedaten oder kein Zugriff.',

    header_checkin:   'Check-in',
    header_present:   'anwesend',

    tab_scan:         'Scanner',
    tab_list:         'Teilnehmer',

    scan_title:       'Badge scannen',
    scan_subtitle:    'Tippen Sie auf die Schaltfläche unten, um die Kamera zu öffnen und den QR-Code eines Teilnehmers zu scannen.',
    scan_btn:         'Badge scannen',
    scan_aim:         'QR-Code des Badges anvisieren',
    scan_flip:        'Kamera wechseln',
    scan_stop:        'Stoppen',

    card_current:     'Aktueller Status',
    card_cancel:      'Abbrechen',
    card_confirm:     'Check-in bestätigen',
    card_already:     'Bereits registriert',

    result_success:   'Check-in bestätigt!',
    result_already:   'Bereits registriert',
    result_error:     'Fehler',
    result_invalid_qr: 'Ungültiger QR-Code',
    result_invalid_sub: 'Dieses Badge enthält keine Kennung.',
    result_bad_format: 'QR-Code unleserlich',
    result_bad_sub:   'Format nicht erkannt.',
    result_network:   'Netzwerkfehler',
    result_network_sub: 'Überprüfen Sie Ihre Verbindung.',

    status_present:   'Anwesend',
    status_absent:    'Nicht angekommen',
    status_cancelled: 'Storniert',

    list_search:      'Teilnehmer suchen…',
    list_present:     'anwesend',
    list_empty:       'Keine Teilnehmer gefunden',
    list_checkin_btn: 'Check-in',
    list_undo_btn:    'Rückgängig',

    loading:          'Laden…',
  },

  en: {
    login_title:      'Check-in Scanner',
    login_email:      'Email',
    login_password:   'Password',
    login_btn:        'Access Scanner',
    login_loading:    'Signing in…',
    login_error:      'Invalid credentials or access denied.',

    header_checkin:   'Check-in',
    header_present:   'present',

    tab_scan:         'Scanner',
    tab_list:         'Participants',

    scan_title:       'Scan a badge',
    scan_subtitle:    'Press the button below to open the camera and scan a participant\'s QR code.',
    scan_btn:         'Scan a badge',
    scan_aim:         'Point at the badge QR code',
    scan_flip:        'Flip camera',
    scan_stop:        'Stop',

    card_current:     'Current status',
    card_cancel:      'Cancel',
    card_confirm:     'Confirm Check-in',
    card_already:     'Already checked in',

    result_success:   'Check-in confirmed!',
    result_already:   'Already checked in',
    result_error:     'Error',
    result_invalid_qr: 'Invalid QR Code',
    result_invalid_sub: 'This badge contains no identifier.',
    result_bad_format: 'Unreadable QR Code',
    result_bad_sub:   'Format not recognized.',
    result_network:   'Network error',
    result_network_sub: 'Check your connection.',

    status_present:   'Present',
    status_absent:    'Not arrived',
    status_cancelled: 'Cancelled',

    list_search:      'Search participant…',
    list_present:     'present',
    list_empty:       'No participants found',
    list_checkin_btn: 'Check-in',
    list_undo_btn:    'Undo',

    loading:          'Loading…',
  },
};

export const SUPPORTED_LANGS = ['fr', 'de', 'en'];

export function getCheckinLang() {
  const saved = localStorage.getItem('checkin_lang');
  if (saved && CHECKIN_I18N[saved]) return saved;
  const browser = navigator.language?.slice(0, 2);
  return CHECKIN_I18N[browser] ? browser : 'fr';
}

export default CHECKIN_I18N;
